export * from './property-verifier.mixin';
